<ng-container *transloco="let t">
  @if (controlPointsList?.length ?? 0 > 0) {
    @for (controlPoint of controlPointsList;track controlPoint) {
      <ng-container>
        <div class="align-items-center d-flex d-lg-none">
          <div class="d-flex flex-column py-3 item-border-bottom flex-grow-1">
            <div class="d-flex align-items-end">
            <span class="fw-bold line-height-12">
                  <app-language-output [hrLabel]="controlPoint?.pointNameHr" [enLabel]="controlPoint?.pointNameEn"
                                       [itLabel]="controlPoint?.pointNameIt"
                                       [siLabel]="controlPoint?.pointNameSlo" [languages]="languages"/>
            </span>

            </div>
            <div>
              <div class="d-inline-flex">
                {{ t("organiser.event.details.control.point.ordinalNumber") }} {{ ': ' }} {{ controlPoint.ordinalNumber }}
              </div>
            </div>

            <div>
              <div class="d-inline-flex">
                <div>
                  {{ t("organiser.event.details.control.point.distanceFromStart") }} {{ ': ' }} {{ (controlPoint.distanceFromStart ?? 0)| raceLengthFormat:translocoService.getActiveLang() }}

                </div>
                <div class="ps-3">
                  {{ t("organiser.event.details.control.point.elevation") }} {{ ': ' }} {{ controlPoint.elevation | raceLengthFormat:translocoService.getActiveLang() }}

                </div>
              </div>
            </div>


            @if (!!controlPoint.limit) {
              <div>
                <div class="d-inline-flex">
                  {{ t("organiser.event.details.control.point.timeLimit") }} {{ ': ' }}
                  {{ controlPoint.limit | localizedDate:"cccc hh:mm" }}
                </div>
              </div>
            }

            @if ((controlPoint.markerTypes?.length ?? 0) > 0) {
              <div class="pt-2">
                <div class="badge_icons">
                  @for (type of controlPoint.markerTypes;track type) {
                    <span class="icon ps-1 pe-1"
                          aria-hidden="true">
                     <img [src]="waypointTypeIcons[type]" width="17"
                          height="17">

              </span>
                  }
                </div>
              </div>

            }
          </div>
        </div>
      </ng-container>
    }
    <div class="table-responsive results-table">

      <div class="d-none d-lg-flex">
        <table class="table table-striped align-middle header">
          <thead class="table-header">
          <tr>
            <th scope="col">{{ t("organiser.event.details.control.point.ordinalNumber") }}</th>
            <th scope="col">{{ t('organiser.event.details.control.point.location') }}</th>
            <th scope="col">{{ t('organiser.event.details.control.point.timeLimit') }}</th>
            <th scope="col">{{ t('organiser.event.details.control.point.distanceFromStart') }}</th>
            <th scope="col">{{ t('organiser.event.details.control.point.elevation') }}</th>
          </tr>
          </thead>
          <tbody #tbody>
            @for (controlPoint of controlPointsList;track controlPoint) {
              <tr class="fs-13-px fw-semibold" [style.height]="'auto'">
                <td>{{ controlPoint.ordinalNumber }}</td>
                <td>
                  <div>
                    <strong>{{ controlPoint.latitude ? "Lat: " : "" }}</strong>{{ controlPoint.latitude }}
                  </div>
                  <div>
                    <strong>{{ controlPoint.longitude ? "Lng: " : "" }}</strong>{{ controlPoint.longitude }}
                  </div>
                </td>
                <td> {{ race!.raceStart|timeLimit:controlPoint.limit }}
                </td>
                <td>{{
                    (controlPoint.distanceFromStart === 0 || controlPoint.distanceFromStart) ?
                      controlPoint.distanceFromStart + " m"
                      : ""
                  }}
                </td>
                <td>{{
                    (controlPoint.elevation === 0 || controlPoint.elevation) ? controlPoint.elevation + " m" :
                      controlPoint.elevation
                  }}
                </td>
              </tr>
            }

          </tbody>
        </table>
      </div>
    </div>
  }
</ng-container>

